export interface IFiltersResponse {
    filters: {
        countryCodes: (string | null)[] | null;
        professions:
            | {
                  professionId: number;
                  phraseId: number;
              }[]
            | null;
    };
}

export enum CAMPAIGN_TYPE {
    'HCP' = 'HCP',
    'CONSUMER' = 'CONSUMER',
}

export interface IReferralOpportunitiesRequest {
    countryCodes?: string[];
    professionIds?: number[];
    campaignType?: CAMPAIGN_TYPE;
    campaignId?: number;
}

export interface IReferralOpportunitiesResponse {
    nonSpecificReferralOpportunities: {
        campaignId: number;
        campaignType: CAMPAIGN_TYPE;
        compensationCurrency: string;
        campaignName: string;
        countryCodes: string[];
        conversionTypeId: string;
        conversionPhraseId: number;
        campaignStartDt: string;
        campaignEndDt: string;
        assigneeStartDt: string | null;
        assigneeEndDt: string | null;
        url: string;
        currencySymbol: string | null;
        currencySymbolPosition: string | null;
        endDt: string;
        programs: {
            id: number;
            programName: string;
            professionIds: number[] | null;
            specialityIds: number[] | null;
            compensationAmount: number;
            professions: {
                id: number;
                phraseId: number;
            }[];
            specialities: {
                id: number;
                phraseId: number;
            }[];
        }[];
    }[];
    specificReferralOpportunities: {
        campaignId: number;
        campaignType: CAMPAIGN_TYPE;
        compensationCurrency: string;
        campaignName: string;
        countryCodes: string[];
        conversionTypeId: string;
        conversionPhraseId: number;
        campaignStartDt: string;
        campaignEndDt: string;
        assigneeStartDt: string | null;
        assigneeEndDt: string | null;
        url: string;
        currencySymbol: string | null;
        currencySymbolPosition: string | null;
        endDt: string;
        programId: number;
        programName: string;
        professionIds: number[] | null;
        professions: { id: number; phraseId: number }[];
        specialityIds: number[] | null;
        specialities: {
            id: number;
            phraseId: number;
        }[];
        compensationAmount: number;
        projectSymbol: string | null;
        projectNumber: number;
        refSurveyId: number;
        targetId: number | null;
        topic: string | null;
        methodologyPhraseId: number | null;
        honoraria: number | null;
        honorariaPhraseId: number | null;
        loi: number | null;
        surveyCompleteDt: string | null;
        professionalFocusPhraseIds: number[] | null;
        healthConditionsPhraseIds: number[] | null;
        inviteMessage: string | null;
        audienceId: number | null;
    }[];
}

export type NonSpecificReferralOpportunityCard = Omit<
    IReferralOpportunitiesResponse['nonSpecificReferralOpportunities'][0],
    'programs'
> & {
    type: 'nonSpecific';
    programs: IReferralOpportunitiesResponse['nonSpecificReferralOpportunities'][0]['programs'][0];
};

export type SpecificReferralOpportunityCard =
    IReferralOpportunitiesResponse['specificReferralOpportunities'][0] & {
        type: 'specific';
    };

export type AffiliateDetails = SpecificReferralOpportunityCard | NonSpecificReferralOpportunityCard;
export interface IRedirectInfoResponse {
    redirectUrl: string;
}

export interface ISurveyLinkResponse {
    hasUserSurveySpecificProgram: boolean;
    startLink: string;
    phraseId: number;
}
